'use client'

import { signIn } from "next-auth/react"
import { useLanguage } from "@/components/LanguageProvider"
import { translations } from "@/lib/translations"
import LanguageSwitcher from "@/components/LanguageSwitcher"

export default function LoginPage() {
  const { lang } = useLanguage()
  const t = translations[lang].login

  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0a',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Arial, Helvetica, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif'
    }}>
      <div style={{ position: 'fixed', top: '1rem', right: '1rem' }}>
        <LanguageSwitcher />
      </div>
      <div style={{ textAlign: 'center', maxWidth: '400px', width: '100%', padding: '2rem' }}>
        <a href="https://internal.goodiezgummies.com/" aria-label="Goodiez Portal Home" style={{ display: 'inline-flex', color: 'inherit', textDecoration: 'none', marginBottom: '1.5rem' }}>
          <img src="/images/logo.png" alt="Goodiez Gummies"
            style={{ width: '100px', display: 'block', borderRadius: '12px' }} />
        </a>
        <h1 style={{ color: '#fff', fontSize: '1.6rem', fontWeight: 800, marginBottom: '0.4rem' }}>
          {t.title}
        </h1>
        <p style={{ color: '#6b7280', fontSize: '0.875rem', marginBottom: '2.5rem', lineHeight: 1.6 }}>
          {t.subtitle}
        </p>
        <button
          onClick={() => signIn('google', { callbackUrl: '/' })}
          style={{
            background: '#fff', color: '#1f1f1f', fontWeight: 600,
            padding: '0.75rem 1.75rem', borderRadius: '9999px',
            border: 'none', cursor: 'pointer', fontSize: '0.95rem',
            display: 'flex', alignItems: 'center', gap: '0.75rem',
            margin: '0 auto', boxShadow: '0 2px 8px rgba(0,0,0,.4)',
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          {t.signInGoogle}
        </button>
        <p style={{ color: '#2d2d2d', fontSize: '0.7rem', marginTop: '2rem' }}>
          {t.restricted}
        </p>
      </div>
    </div>
  )
}
